import styled from '@emotion/styled'

export const ExpertBalanceSheetTabsWrapper = styled.div`
  flex-shrink: 0;
`
